import { PaginatorContract } from "@shared/services/api/types";
import { flatten } from "lodash";
import { InfiniteData } from "react-query";

export function getFlattenedData<T>(
  data: InfiniteData<PaginatorContract<T>>
): T[] {
  const pagesData = data.pages.map((page) => page.results);

  return flatten(pagesData);
}

export function tryParseJson<T = unknown>(value: string): T | undefined {
  try {
    return JSON.parse(value) as T;
  } catch (error) {
    return undefined;
  }
}
